// CardDetails.tsx
import { Box, Chip, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import * as React from 'react';

type Props = {
    subtitle?: string;
    chipLabel?: string;
    chipIcon?: React.ReactElement;
    showChip?: boolean;
    size: 'sm' | 'md';
};

const StyTypography = styled(Typography, {
    name: 'styCardSubtitle',
    shouldForwardProp: (prop) => prop !== 'size',
})<{ size: 'sm' | 'md' }>(({ size }) => ({
    // creates ellipsis but on 2 lines
    // see https://css-tricks.com/almanac/properties/l/line-clamp/
    display: '-webkit-box',
    WebkitLineClamp: size === 'sm' ? '2' : '1',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    // we use max height for old Firefox version that do not support line clamp
    maxHeight: size === 'sm' ? '40px' : '20px',
    wordBreak: 'break-word',
}));

export const GenericCardDetails = ({
    subtitle = undefined,
    chipLabel = undefined,
    chipIcon = undefined,
    showChip = false,
    size,
}: Props) => {
    const theme = useTheme();

    if (!subtitle && (!chipLabel || !showChip)) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: size === 'sm' ? 'baseline' : 'center',
                gap: theme.spacing(1),
            }}
        >
            {subtitle && <StyTypography size={size}>{subtitle}</StyTypography>}

            {subtitle && chipLabel && showChip && <Typography>-</Typography>}

            {chipLabel && showChip && (
                <Chip
                    sx={{ backgroundColor: theme.palette.lightGrey }}
                    icon={chipIcon}
                    label={chipLabel}
                    size="small"
                />
            )}
        </Box>
    );
};
